import { fromZonedTime } from 'date-fns-tz'

export function forceUtcFromLocalDateParts(parts: Date) {
  return new Date(
    Date.UTC(
      parts.getFullYear(),
      parts.getMonth(),
      parts.getDate(),
      parts.getHours(),
      parts.getMinutes()
    )
  )
}

export function forceTzToMinute(timeZone: string, date: Date) {
  const noTzDate = [
    date.getUTCFullYear(),
    String(date.getUTCMonth() + 1).padStart(2, '0'),
    String(date.getUTCDate()).padStart(2, '0'),
  ].join('-')
  const noTzFormat = `${noTzDate}T${String(
    date.getUTCHours()
  ).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(
    2,
    '0'
  )}`
  return fromZonedTime(noTzFormat, timeZone)
}
